export default {
    list: [
        {
            name: 'Sudhanshu Shekhar',
            position: 'Product',
            linkendIn: 'https://www.linkedin.com/in/sudshekhar02/',
            image: require('../images/team/sudhanshu.png'),
        },
        {
            name: 'Mayank Natani',
            position: 'Engineering',
            linkendIn: 'https://www.linkedin.com/in/mayank-natani-71671440',
            image: require('../images/team/mayank.png'),
        },
        {
            name: 'Vibhav Srivastava',
            position: 'Engineering',
            linkendIn: 'https://www.linkedin.com/in/vibhav-s/',
            image: require('../images/team/vibhav.png'),
        },
        {
            name: 'Manish Shukla',
            position: 'Engineering',
            linkendIn: 'https://www.linkedin.com/in/mkshukla/',
            image: require('../images/team/manish.png'),
        },
        {
            name: 'Ashok Rajan',
            position: 'Design',
            linkendIn: 'https://www.linkedin.com/in/ashokrajan28/',
            image: require('../images/team/ashok.png'),
        },
        {
            name: 'Vishwajeet Kushmariya',
            position: 'Engineering',
            linkendIn: 'https://www.linkedin.com/in/vishwajeet007/',
            image: require('../images/team/vishwajeet.png'),
        },
        {
            name: 'Mohit Manuja',
            position: 'Engineering',
            linkendIn: 'https://www.linkedin.com/in/mohitmanuja/',
            image: require('../images/team/mohit.png'),
        },
        {
            name: 'Kushal Kamra',
            position: 'Engineering',
            linkendIn: 'https://www.linkedin.com/in/kushalk',
            image: require('../images/team/kushal.png'),
        },
        {
            name: 'Nitish Alodia',
            position: 'Engineering',
            linkendIn: 'https://www.linkedin.com/in/nitish-alodia-884b1931/',
            image: require('../images/team/nitish.png'),
        },
        {
            name: 'Bharat Akkinepalli',
            position: 'Engineering',
            linkendIn:
                'https://www.linkedin.com/in/bharat-akkinepalli-ba0b7223/',
            image: require('../images/team/bharat.png'),
        },
        {
            name: 'Rohit Rao',
            position: 'Design',
            linkendIn: 'https://www.linkedin.com/in/rohituxd/',
            image: require('../images/team/rohit.png'),
        },
        {
            name: 'Shireesha Bongarala',
            position: 'Engineering',
            linkendIn: 'https://www.linkedin.com/in/developervenkat/',
            image: require('../images/team/shireesha.png'),
        },
        {
            name: 'Venkataramana Neelapala',
            position: 'Engineering',
            linkendIn: 'https://www.linkedin.com/in/shireesha-bongarala/',
            image: require('../images/team/venkataramana.png'),
        },
    ],
};
